import { type SxProps, type Theme } from '@mui/material'

export const CARD_WIDTH = '260px'

export const styles = {
  intro: {
    mb: '20px'
  } satisfies SxProps<Theme>,
  districtsHint: {
    mb: '16px'
  } satisfies SxProps<Theme>,
  cardRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'stretch'
  } satisfies SxProps<Theme>,
  card: {
    width: CARD_WIDTH,
    display: 'flex',
    flexDirection: 'column'
  } satisfies SxProps<Theme>,
  cardHeader: (headerColor: string) => ({
    backgroundColor: headerColor,
    borderRadius: '12px 12px 0 0',
    minHeight: '57px',
    p: '16px',
    display: 'flex',
    alignItems: 'center'
  } satisfies SxProps<Theme>),
  cardTitle: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  cardBody: (bodyColor: string, headerColor: string) => ({
    backgroundColor: bodyColor,
    border: `5px solid ${headerColor}`,
    borderRadius: '0 0 12px 12px',
    p: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    flexGrow: 1
  } satisfies SxProps<Theme>),
  buildingLink: (notStarted: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    color: notStarted ? 'var(--purple-500)' : 'var(--blue-500)',
    fontWeight: 600,
    textAlign: 'left'
  } satisfies SxProps<Theme>),
  actionsCard: {
    width: CARD_WIDTH,
    backgroundColor: 'var(--purple-50)',
    borderRadius: '16px',
    boxShadow: 'var(--shadow-md)',
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '40px'
  } satisfies SxProps<Theme>,
  actionsBlock: {
    textAlign: 'center'
  } satisfies SxProps<Theme>,
  actionsTitle: {
    mb: '24px'
  } satisfies SxProps<Theme>
}
